// ----------------------------------------------------------------------

export function setCookie(name, value, days = 7) {
  try {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  } catch (error) {
    console.error('Error setting cookie:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export function getCookie(name) {
  try {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  } catch (error) {
    console.error('Error getting cookie:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export function removeCookie(name) {
  try {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  } catch (error) {
    console.error('Error removing cookie:', error);
    throw error;
  }
}
